if (typeof BSS_B2B != undefined) {
  if(window.location.pathname.includes("/products/")) {
    setTimeout(() =>{
      const targetPrice = document.querySelector(".product__info-container .no-js-hidden");
      if (targetPrice) {
        const mutationObserver = new MutationObserver((recordList, observe) => {
        const productForm = document.querySelector("[bss-b2b-product-form]");
          BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
        });
        mutationObserver.observe(targetPrice, { attributes: true });
      }
    }, 1000)
  }
}